<template lang="pug">
  b-container
    b-form-row.align-items-center.mt-3.mb-4
      b-col
        h4.mb-0 Usuarios
    platforms-tabs.mb-3(:active="platform", @click:active="platform = $event")
    b-form-group(label="Buscar usuario")
      b-input-group
        b-form-input(placeholder="Nombre de usuario...", v-model="search_user", type="search")
        b-input-group-append
          b-input-group-text
            search-icon.text-secondary.icon-sm
    b-card(no-body)
      b-table.card-table.mb-0(:fields="fields", :items="users", show-empty, responsive)
        template(v-slot:empty)
          p.mb-0.text-secondary No hay usuarios disponibles
        template(v-slot:emptyfiltered)
          p.mb-0 Sin coincidencias
        template(v-slot:cell(first_name)="{ item }")
          .d-flex.align-items-center
            b-img.mr-2(:src="item.profile_pic", width="30", height="30", rounded="circle", @error="item.error = true", v-if="!item.error && item.profile_pic", style="object-fit: cover;")
            span(v-if="item.first_name || item.last_name") {{ item.first_name }} {{ item.last_name }}
            span.text-secondary(v-else) N/D
        template(v-slot:cell(gender)="{ item }")
          p.mb-0(:class="parseGender(item.gender) == 'N/D' ? 'text-secondary' : ''") {{ parseGender(item.gender) }}
        template(v-slot:cell(bot_enabled)="{ item }")
          p.mb-0(:class="item.bot_enabled ? 'text-success' : 'text-danger'") {{ item.bot_enabled ? 'Bot activo' : 'Bot apagado' }}
        template(v-slot:cell(createdAt)="{ item }")
          p.mb-0 {{ $moment(item.createdAt).format('DD-MMM-YY') }}
        template(v-slot:cell(last_interaction_time)="{ item }")
          p.mb-0 {{ $moment(item.last_interaction_time).format('DD-MMM-YY') }}
        template(v-slot:cell(is_subscribed)="{ item }")
          b-form-checkbox(switch, v-model="item.is_subscribed", @change="updateUser(item, 'is_subscribed')") {{item.is_subscribed ? 'Sí' : 'No'}}
        template(v-slot:cell(banned)="{ item }")
          b-form-checkbox(switch, v-model="item.banned", @change="updateUser(item, 'banned')") {{item.banned ? 'Sí' : 'No'}}

    b-row(no-gutters)
      b-col(md="8")
        .d-flex.align-items-center.mb-3
          b-pagination.mb-0.mr-3(:value="paginationCurrentPage", @change="loading = true;paginationPageChanged($event, 'getUsers')", :per-page="v_paginationLimit", :total-rows="v_paginationItemsCount", v-if="v_paginationShow")
          b-spinner(small, variant="primary", v-if="loading")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const userController = createNamespacedHelpers('user')

import PlatformsTabs from '@/components/PlatformsTabs.vue'
import _debounce from 'lodash.debounce'

export default {
  data () {
    return {
      loading: false,
      fields: [
        {
          key: 'first_name',
          label: 'Nombre'
        },
        {
          key: 'gender',
          label: 'Sexo'
        },
        {
          key: 'bot_enabled',
          label: 'Estado del bot'
        },
        {
          key: 'createdAt',
          label: 'Primer msj'
        },
        {
          key: 'last_interaction_time',
          label: 'Último msj'
        },
        {
          key: 'is_subscribed',
          label: 'Suscrito a broadcast'
        },
        {
          key: 'banned',
          label: 'Bloqueado'
        }
      ],
      platform: 'all',
      search_user: ''
    }
  },
  computed: {
    ...userController.mapState({
      users: state => state.users
    }),
  },
  methods: {
    ...mapActions(['user/all', 'user/search', 'user/update']),
    getUsers () {
      let self = this
      this.loading = true
      // this.showLoadingScreen()

      this['user/all']({
        account_id: self.$route.params.account_id,
        params: {
          ...self.paginationParamsObject,
          platform: self.platform
        },
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
          }
        }
      })
    },
    searchUser () {
      let self = this
      this.loading = true
      // this.showLoadingScreen()

      this['user/search']({
        params: {
          ...self.paginationParamsObject,
          platform: self.platform,
          text: self.search_user,
          account_id: self.$route.params.account_id,
        },
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
          }
        }
      })
    },
    updateUser (user, value) {
      let self = this
      this.loading = true

      this['user/update']({
        user_id: user.user_id,
        [value]: user[value],
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Usuario actualizado')
          }
        }
      })
    },
    parseGender (gender) {
      switch (gender) {
        case 'male':
          return 'Masculino'
          break
        case 'Female':
          return 'Femenino'
          break
        default:
          return 'N/D'
      }
    }
  },
  created () {
    this.updateList = _debounce((reset = false) => {
      if (reset) this.resetPaginationData()
      if (this.search_user) {
        this.searchUser()
      } else {
        this.getUsers()
      }
    }, 300)
  },
  mounted () {
    this.getUsers()
  },
  components: { PlatformsTabs },
  watch: {
    platform (value) {
      if (value) {
        this.updateList(true)
      }
    },
    search_user (value) {
      this.updateList(true)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
